import Skeleton from 'react-loading-skeleton';
import S from './BillingPageSkeleton.module.scss';
export const BillingPageSkeleton = () => {
  return <div className={S.layout} data-sentry-component="BillingPageSkeleton" data-sentry-source-file="BillingPageSkeleton.tsx">
      <Skeleton width={150} height={28} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
      <Skeleton width={100} inline height={22} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
      <Skeleton width={100} inline height={22} style={{
      marginLeft: '5px'
    }} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
      <div style={{
      display: 'flex',
      marginTop: '50px'
    }}>
        <aside style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '5px'
      }}>
          <Skeleton width={170} height={28} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
          <Skeleton width={170} height={28} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
          <Skeleton width={170} height={28} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
        </aside>
        <main style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '80px'
      }}>
          <Skeleton width={200} height={28} style={{
          marginBottom: '50px'
        }} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
          <div style={{
          display: 'flex',
          gap: '80px',
          marginBottom: '20px'
        }}>
            <div style={{
            display: 'flex',
            gap: '50px'
          }}>
              <Skeleton width={80} height={20} style={{
              marginRight: '100px'
            }} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
              <Skeleton width={70} height={20} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
              <Skeleton width={70} height={20} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
              <Skeleton width={70} height={20} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
              <Skeleton width={70} height={20} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
              <Skeleton width={70} height={20} style={{
              marginLeft: '20px'
            }} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
            </div>
          </div>
          <div>
            <Skeleton width={800} height={50} count={3} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
          </div>
          <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          justifyContent: 'center',
          marginTop: '50px'
        }}>
            <Skeleton width={35} height={35} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
            <Skeleton width={35} height={35} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
            <Skeleton width={35} height={35} data-sentry-element="Skeleton" data-sentry-source-file="BillingPageSkeleton.tsx" />
          </div>
        </main>
      </div>
    </div>;
};